import type { Episode, EpisodeContent, Offer, PromotedBundleEdge } from '@/@types/graphql-types';
import type { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';

export const enum BuyboxOfferCategory {
	STREAM = 'stream',
	RENT = 'rent',
	BUY = 'buy',
	PHYSICAL = 'physical',
	BUNDLE = 'bundle',
	CINEMA = 'cinema',
}

// EXP_LINEAR_TV: only fetched (via @include) on the buybox queries, and only for users in the experiment.
export type LinearOfferEpisode = {
	offer: Pick<Offer, 'id' | 'availableFromTime' | 'availableToTime'>;
	episode: Pick<Episode, 'id'> & {
		content: Pick<EpisodeContent, 'title' | 'seasonNumber' | 'episodeNumber'>;
	};
};

export type LinearTitleOffer = TitleOfferFragment & {
	offerEpisodes?: LinearOfferEpisode[] | null;
};

export type TitleOffers = {
	stream: TitleOfferFragment[];
	buy: TitleOfferFragment[];
	rent: TitleOfferFragment[];
	free: TitleOfferFragment[];
	linear: LinearTitleOffer[];
	cinema: TitleOfferFragment[];
	bundles?: PromotedBundleEdge[];
	offerCount: number;
	maxOfferUpdatedAt: string;
};
